import {
  SkeletonButton,
  SkeletonText,
  SkeletonTable,
} from '@dev-spendesk/grapes';
import React from 'react';

export const MembersTableLoader = () => {
  return (
    <div className="w-full">
      <div className="mb-16 flex gap-24">
        <div className="flex grow flex-col gap-4">
          <SkeletonText size="xl" width="150px" />
          <SkeletonText width="150px" />
        </div>

        <SkeletonButton />
        <SkeletonButton />
      </div>
      <SkeletonTable
        columns={[
          {
            cell: <SkeletonText width="80%" />,
            header: <SkeletonText width="50%" />,
          },
        ]}
        numberOfRows={5}
        withHeader
      />
    </div>
  );
};
